export default {
  computed: {
    learnerIsViewingAPendingBookingInitiatedByAdvisor () {
      return this.booking.isAdvisorInitiatedAndPendingApproval && !this.isAuthenticatedUserAdvisorOfBooking
    },
    advisorIsViewingAPendingBookingTheyInitiated () {
      return this.booking.isAdvisorInitiatedAndPendingApproval && this.isAuthenticatedUserAdvisorOfBooking
    },
    isAuthenticatedUserAdvisorOfBooking () {
      return this.userIsAuthenticated && this.booking.advisorId === this.authenticatedUser.id
    },
    otherUser () {
      if (this.isAuthenticatedUserAdvisorOfBooking) {
        return this.booking.learner
      }
      return this.booking.advisor
    },
    otherUserName () {
      return this.advisorIsViewingAPendingBookingTheyInitiated ? this.otherUser.firstName : this.otherUser.fullName
    },
  }
}
